const CreditCard = (props) => {
  const { creditCard } = props;
  if (!creditCard) {
    return null;
  }
  return (
    <>
      {renderCreditCardImage(creditCard.cardBrand)}
      Card ending in{' '}
      {creditCard.maskedCardNumber.substr(
        creditCard.maskedCardNumber.length - 4
      )}
      <br />
      Exp {creditCard.expiryMo}/{creditCard.expiryYr}
    </>
  );
};

export default CreditCard;

const renderCreditCardImage = (cardBrand) => {
  switch (cardBrand) {
    case 'MasterCard': {
      return (
        <span className="c7-account__credit-cards__mastercard">
          {cardBrand}
        </span>
      );
    }
    case 'Visa': {
      return (
        <span className="c7-account__credit-cards__visa">{cardBrand}</span>
      );
    }
    case 'American Express': {
      return (
        <span className="c7-account__credit-cards__amex">{cardBrand}</span>
      );
    }
    case 'Discover': {
      return (
        <span className="c7-account__credit-cards__discover">{cardBrand}</span>
      );
    }
    case 'JCB': {
      return <span className="c7-account__credit-cards__jcb">{cardBrand}</span>;
    }
    case 'Diners Club': {
      return (
        <span className="c7-account__credit-cards__dinersclub">
          {cardBrand}
        </span>
      );
    }
    default: {
      return <>{cardBrand}</>;
    }
  }
};
